import { useCallback } from 'react';
import { Loader } from 'components';
import { Typography, visuallyHidden } from 'bonfire-kindling';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useFeatureFlags, useInfiniteScroll } from 'helpers/hooks';
import OpportunitiesCard from './OpportunitiesCard';
import OpportunitiesEmpty from './OpportunitiesEmpty';

function OpportunitiesList({ opportunitiesQuery, logInToOrganizationDomain, currentSearchFilter }) {
  const { t } = useTranslation();
  const { isFlagEnabled } = useFeatureFlags();

  const { opportunities, fetchNextPage, isLoading, hasNextPage, isFetchingNextPage } =
    opportunitiesQuery;

  const loadTriggerRef = useInfiniteScroll(
    useCallback(() => {
      fetchNextPage();
    }, [fetchNextPage]),
    { rootMargin: '200px' }
  );

  if (isLoading) {
    return <Loader variant="puff" isCentered />;
  }

  return (
    <>
      <Switch>
        <Route path="/opportunities/recommended">
          <Typography style={visuallyHidden} component="h2">
            {t('opportunities.screen_reader.recommended')}
          </Typography>
        </Route>
        <Route path="/opportunities/following">
          <Typography style={visuallyHidden} component="h2">
            {t('opportunities.screen_reader.followed')}
          </Typography>
        </Route>
        <Route path="/opportunities/all">
          <Typography style={visuallyHidden} component="h2">
            {t('opportunities.screen_reader.all')}
          </Typography>
        </Route>
        <Route path="/opportunities/saved">
          {isFlagEnabled('FF_25_RELEASE_TOGGLE_PV_SAVED_SEARCH') ? (
            <Typography style={visuallyHidden} component="h2">
              {t('opportunities.screen_reader.saved_search')}
            </Typography>
          ) : (
            <Redirect to="/opportunities/recommended" />
          )}
        </Route>
      </Switch>
      {opportunities.length === 0 && (
        <OpportunitiesEmpty currentSearchFilter={currentSearchFilter} />
      )}
      {opportunities.map(opportunity => (
        <OpportunitiesCard
          {...opportunity}
          key={opportunity.ProjectUUID}
          logInToOrganizationDomain={logInToOrganizationDomain}
        />
      ))}
      {hasNextPage &&
        (isFetchingNextPage ? <Loader variant="puff" isCentered /> : <div ref={loadTriggerRef} />)}
    </>
  );
}

export default OpportunitiesList;
